<button nz-button nzSize="large" [nzBlock]="fullSize" (click)="openLotAddNoteFormModal()">
  {{ 'LOT_ADD_NOTE.ADD_TITLE' | translate }}
</button>
